import {
  CreatePOI,
  CreatePOITranslationData,
  CreateRouteTranslationData,
  UpdateRouteAndTranslationsData,
} from "../api/edits/editRoute.requests";
import {
  POI,
  POITranslation,
  RouteState,
  RouteTranslation,
} from "../api/edits/editRoute.responses";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function convertTranslationsToDatabaseFormat<T, U>(
  translations: { [languageCode: string]: T },
  mapFn: (translation: T, languageCode: string) => U
): U[] {
  return Object.keys(translations).map((languageCode) => {
    const translation = translations[languageCode];
    return mapFn(translation, languageCode);
  });
}

export function prepareRouteDataForDB(
  routeStateData: RouteState
): UpdateRouteAndTranslationsData {
  const revertedTranslationsForRoute: CreateRouteTranslationData[] =
    convertTranslationsToDatabaseFormat(
      routeStateData.routeTranslations,
      (translation: RouteTranslation, languageCode: string) => ({
        name: translation.name,
        description: translation.description,
        languageCode: languageCode,
      })
    );

  const routeData: UpdateRouteAndTranslationsData = {
    routeTranslations: revertedTranslationsForRoute,
    appleStoreId: routeStateData.appleStoreId,
    playStoreId: routeStateData.playStoreId,
    timeDuration: routeStateData.timeDuration,
    priceInEuros: routeStateData.priceInEuros,
    previewImagePath: routeStateData.previewImagePath,
    cityId: routeStateData.city.id,
    sponsorId: routeStateData.sponsor.id,
  };

  return routeData;
}

export function preparePOIDataForDB(pointsOfInterest: POI[]): CreatePOI[] {
  const POIdata: CreatePOI[] = [];

  for (const poi of pointsOfInterest) {
    const { pointOfInterestTranslations, ...poiAttributes } = poi;
    let point: CreatePOI;

    const revertedTranslationsForPoint: CreatePOITranslationData[] =
      convertTranslationsToDatabaseFormat(
        pointOfInterestTranslations,
        (translation: POITranslation, languageCode: string) => ({
          name: translation.name,
          text: translation.text,
          audioPath: translation.audioPath,
          languageCode: languageCode,
        })
      );

    point = {
      ...poiAttributes,
      pointOfInterestTranslations: revertedTranslationsForPoint,
    };

    POIdata.push(point);
  }

  return POIdata;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
